import type {GetBuildProblemTreeApiArg} from '../../../../services/rest'
import type {FilterQueryParams} from '../Problems.hooks'

export const getBuildProblemsLocator = (
  baseLocator: string,
  {investigated, muted, assignee}: FilterQueryParams,
  onlyInvestigated = false,
  currentUser?: string | null,
) => {
  let investigatedLocator = investigated ? `currentlyInvestigated:${investigated}` : ''
  let assigneeLocator = assignee ? `assignee:${assignee}` : ''

  const mutedLocator = muted ? `currentlyMuted:${muted}` : ''
  if (onlyInvestigated) {
    investigatedLocator = 'currentlyInvestigated:true'
    assigneeLocator = `assignee:${currentUser}`
  }

  return [baseLocator, investigatedLocator, mutedLocator, assigneeLocator].filter(Boolean).join(',')
}

export const getBuildProblemsTreeFields = () =>
  'node(type,name,parentId,id,problemCount,childrenCount),' +
  'leaf(nodeId,problemEntries(count,' +
  `entry(problemOccurrence(id,details,build(id,statusText),problem(id),newFailure,logAnchor),` +
  'alsoIn(build(id,buildTypeId)),build(id,buildTypeId,number,status,state,statusText),' +
  'mutes(count,mute(id,state,resolution(type,time),assignment(text,timestamp,user(id,name,username)),scope(project(id,name),buildTypes(buildType(id,name))),target(problems(problem)))),' +
  `investigations(count,investigation(id,state,resolution(type,time),assignee(id,name,username,avatars),assignment(text,timestamp,user(id,name,username)),scope(project(id,name),buildTypes(buildType(id,name))))))))`

export const getBuildProblemsArg = (locator: string): GetBuildProblemTreeApiArg => ({
  locator,
  treeLocator: locator,
})
